<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>關於和平電力</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <div class="sectTit">全世界唯一港電廠循環經濟園區一份子</div>
        <p>臺灣水泥股份有限公司於 1997 年與中電 (國際) 股份有限公司合資成立「和平電力股份有限公司」，於花蓮縣秀林鄉和平村設立和平電廠。它是台灣東部發電量最大的電廠，提供北部兩大重要城市 - 宜蘭約 95% 以及新北市約 20% 的用電需求，供應全台近 4% 的電力，目前更是台灣北東電網極為重要的供電來源。</p>
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <swiper
          :modules = "modules"
          :slides-per-view="1"
          :space-between="1"
          :autoplay="{delay:3000, disableOnInteraction:false}"
          :speed="1000"
          :loop="true"
          :pagination="{clickable:true}"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          class="swiper"
        >
          <swiper-slide class="cover cover1"></swiper-slide>
          <swiper-slide class="cover cover2"></swiper-slide>
          <swiper-slide class="cover cover3"></swiper-slide>
          <swiper-slide class="cover cover4"></swiper-slide>
          <swiper-slide class="cover cover5"></swiper-slide>
        </swiper>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <p>和平電廠位在和平工業區內，這是一個電廠、水泥廠與工業港融合在一起的「港電廠循環經濟園區」，電廠發電所需的煤炭 100% 採用密閉式儲存、運送，全程使用密閉式輸送帶。和平電廠也是全球唯一使用煤炭發電但卻未設置灰塘的火力發電廠，其他燃煤電廠中常見的露天堆存煤炭，在這邊完全看不到。</p>
        <div class="tuo">
          <div class="sign">
            <img src="@/assets/aboutHPPC/pic3_01.png" />
          </div>
          <div class="desp">
            你一定好奇灰塘是什麼? 就是煤炭燃燒完後，產生大量煤灰，一般的火力發電廠會將煤灰投入海洋封圍填海，而和平電力則是透過全密閉輸送廊道將煤灰運至隔壁的台泥和平水泥廠作為原料，百分百完全再利用，所以不會有煤灰到海洋灰塘填海或被掩埋；而和平水泥廠每年也就近提供 6 萬噸的石灰石粉作為和平電廠的硫氧化物吸附劑，協助電廠降低 95％ 以上硫氧化物的排放，其反應後產生的脫硫石膏又成為水泥廠的主要原料之一。
          </div>
        </div>
        <div class="left">
          <div class="imgContainer3-1"></div>
        </div>
        <div class="right">
          <div class="imgContainer3-2">
            <div class="imgTit">和平電廠運煤輸送帶</div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </section>
    <section class="sect4">
      <div class="ctx">
        <div class="sectTit">和電密碼</div>
        <div class="contOver">
          <img class="diagram" src="../../assets/aboutHPPC/pic4_02.png" />
          <img class="dist" src="../../assets/aboutHPPC/pic4_03.png" />
        </div>
        <div class="specList">
          <div class="item" v-for="(row, idx) in specList" :key=idx>
            <div class="tit">
              <img class="icon" :src="setPowerSpecIcon(row.icon)" />
              {{row.tit}}
            </div>
            <div class="spec">
              <div v-html="row.spec"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="sect5">
      <div class="ctx">
        <div class="sectTit">導入系統加強各項管理</div>
        <p>台泥企業團致力成為全神貫注，處理人類文明與大自然之間複雜關係的綠色環境工程公司。和平電力秉持母公司永續經營的願景，全面導入 ISO 9001 品質管理、ISO 45001 職安衛管理、ISO 14001 環境管理及 ISO 50001 能源管理等，積極建立制度化的管理框架。</p>
        <div class="isoList">
          <div class="item" v-for="(row, idx) in iso" :key="idx">
            <div class="icon">
              <img :src="require(`@/assets/aboutHPPC/${row.icon}`)" />
            </div>
            <div class="txt">
              <div class="tit"><big>{{row.tit}}</big></div>
              <div v-html="row.desp"></div>
            </div>
          </div>
        </div>
        <!-- <a class="powerReportLink" :href="setUrl(urlPath.aboutPowerReport)">→ 電業簡明月報/年報</a> -->
        <a :href="setUrl(urlPath.aboutPowerReport)"><img src="@/assets/aboutHPPC/reportLinkBtn.png" /></a>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ImgContainerAutoResize, Util, UrlPath } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

import { ref } from 'vue';

export default defineComponent({
  name: 'AboutHPPC',
  components: {
    Header,
    Footer,
    Swiper,
    SwiperSlide
  },
  setup() {
    const onSwiper = (swiper: any) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay]
    };
  },
  data() {
    return {
      urlPath: UrlPath,
      util: Util,
      specList: [
        {
          tit: "供電型式",
          spec: "採雙迴路供電",
          icon: "specIcon4_01.png"
        },
        {
          tit: "迴路名稱",
          spec: "白線 (高絕緣側)</br>紅線 (低絕緣側)",
          icon: "specIcon4_02.png"
        },
        {
          tit: "導線型式",
          spec: "三相、四導體<br><b>795MCM</b> 鋼心鋁絞線",
          icon: "specIcon4_03.png"
        },
        {
          tit: "電壓等級",
          spec: "三相 <b>345,000</b> 伏特<br>(<b>345kV</b>)",
          icon: "specIcon4_04.png"
        },
        {
          tit: "額定電流",
          spec: "每相 <b>4000A</b>",
          icon: "specIcon4_05.png"
        }
      ],
      iso: [
        {
          tit: "ISO 9001 品質政策",
          desp: "全員參與，同心協力，持續改善，<br>永續經營，優質電力，服務客戶。",
          icon: "iso9001.png"
        },
        {
          tit: "ISO 45001 職安衛政策",
          desp: "珍重生命落實環安，教育訓練自動檢查，<br>健全設施傷害歸零，加強溝通和諧發展。",
          icon: "iso45001.png"
        },
        {
          tit: "ISO 14001 環境政策",
          desp: "恪遵環境保護法令，立志環保楷模，<br>採用最佳可行技術，減少污染排放，<br>持續執行工業減廢，做好資源回收，<br>落實執行環安教育，普及工安意識，<br>建立稽核追蹤制度，確保持續改善。",
          icon: "iso14001.png"
        },
        {
          tit: "ISO 50001 能源政策",
          desp: "遵守能源法規及節能要求；<br>竭力達成能源目標與標的；<br>支持節能設計並優先採購；<br>持續提昇能源管理與績效。",
          icon: "iso50001.png"
        }
      ]
    }
  },
  methods:{
    setPowerSpecIcon: function(file: string) {
      return require(`@/assets/aboutHPPC/${file}`);
    },
    setUrl: function(pathName: string) {
      return Util.setUrl(pathName);
    },
  },
  mounted() {
    // let swiperPageination = (document.querySelector(".swiper-pagination") as HTMLElement).cloneNode(true);
    // (document.querySelector(".swiper") as HTMLElement).after(swiperPageination);    

    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover1") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover2") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover3") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover4") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover5") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-1") as HTMLElement, 0.72);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-2") as HTMLElement, 0.8);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-2") as HTMLElement, 0.8);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: url("@/assets/aboutHPPC/kv.webp");
  background-position: center 35%;
  background-size: cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 .sectTit {
  margin: 0 0 10px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect1 p {
  line-height: 2em;
}

.sect2 {
  background: #F4F3F3;
}

.sect2 .ctx {
  padding: 0;
  background: #F4F3F3;
}

.sect2 .swiper {
  border-radius: 30px;
}

.sect2 .swiper .swiper-wrapper {
  /* overflow: hidden; */
}

.sect2 .swiper .cover1 {
    background: url(../../assets/aboutHPPC/carousel2_01.webp) center;
    background-size: cover;
}

.sect2 .swiper .cover2 {
    background: url(../../assets/aboutHPPC/carousel2_02.webp) center;
    background-size: cover;
}

.sect2 .swiper .cover3 {
    background: url(../../assets/aboutHPPC/carousel2_03.webp) center 85%;
    background-size: cover;
}

.sect2 .swiper .cover4 {
    background: url(../../assets/aboutHPPC/carousel2_04.webp) center;
    background-size: cover;
}

.sect2 .swiper .cover5 {
    background: url(../../assets/aboutHPPC/carousel2_05.webp) center;
    background-size: cover;
}

.sect2 .swiper .swiper-pagination {
  /* bottom: -40px !important; */
}

.sect2 .swiper .swiper-pagination .swiper-pagination-bullet {
  width: 15px;
  height: 15px;
  border: solid 1px #fff;
  background: #404040;
  opacity: 0.8;
}

.sect2 .swiper .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #fff;
}

/* .swiper-button-next:after {
  padding: 10px;
  font-size: 60px;
  background: #00000088;
} */

.sect3 .ctx {
  padding: 40px 0 100px;
}

.sect3 p {
  line-height: 2em;
}

.sect3 .tuo {
  margin: 20px 0 60px;
  display: flex;
  justify-content: space-between;
}

.sect3 .tuo .sign {
  flex: 0 0 100px;
}

.sect3 .tuo .sign img {
  width: 100%;
}

.sect3 .tuo .desp {
  flex: 0 1 auto;
  margin: 0 0 0 40px;
  line-height: 2em;
}

.sect3 .left {
  width: 50%;
  float: left;
  line-height: 2em;
  letter-spacing: 1px;
}

.sect3 .right {
  width: 45%;
  float: right;
}

.sect3 .left .imgContainer3-1 {                         
  background: url(../../assets/aboutHPPC/pic3_02.png) center no-repeat;
  background-size: cover;
}

.sect3 .right .imgContainer3-2 {
  position: relative;
  border-radius: 30px;
  overflow: hidden;
  background: url(../../assets/aboutHPPC/pic3_03.jpg) right center no-repeat;
  background-size: cover;
}

.sect3 .right .imgContainer3-2 .imgTit {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  text-align: center;
  color: #fff;
  background: #00000066;
}

.sect4 {
  background: #63BFAA;
}

.sect4 .sectTit {
  width: 250px;
  height: 200px;
  margin: -100px 0 -30px 50px;
  padding: 10px 0 0;
  box-sizing: border-box;
  /* position: absolute;
  left: 0;
  top: 0; */
  text-align: center;
  letter-spacing: 3px;
  font-size: 36px;
  color: #fff;
  background: url(../../assets/aboutHPPC/pic4_01.png), #40404000;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.sect4 .diagram {
  width: 1200px;
}

.sect4 .dist {
  width: 1200px;
}

.sect4 .specList {
  margin: 20px 0 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect4 .specList .item {
  flex: 0 0 19%;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 20px;
  background: #fff;
}

.sect4 .specList .item .tit {
  margin: -25px 0 0;
  padding: 0 0 10px;
  border-bottom: solid 1px #63BFAA;
  font-size: 28px;
  color: #EA9876;
}

.sect4 .specList .item .tit .icon {
  width: 60px;
  margin: 0 0 0 -15px;
  vertical-align: bottom;
}

.sect4 .specList .item .spec {
  height: 50%;
  padding: 10px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.sect5 .sectTit {
  margin: 0 0 10px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect5 p {
  line-height: 2em;
}

.sect5 .isoList {
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect5 .isoList .item {
  flex: 0 0 48%;
  margin: 10px 0;
  padding: 15px 20px;
  box-sizing: border-box;
  border-radius: 10px;
  border: solid 1px #d0d0d0;
  background: #fff
}

.sect5 .isoList .item .icon {
  width: 20%;
  display: inline-block;
  vertical-align: top;
}

.sect5 .isoList .item .icon img {
  width: 100%;
  vertical-align: bottom;
}

.sect5 .isoList .item .txt {
  width: 75%;
  margin: 0 0 0 5%;
  display: inline-block;
  vertical-align: top;
}

.sect5 .isoList .item .txt .tit {
  margin: 0 0 5px;
  color: #63BFAA;
}

.sect5 .powerReportLink {
  margin: 40px 0 0;
  padding: 5px 20px 7px;
  display: inline-block;
  border: solid 1px #fff;
  border-radius: 30px;
  font-size: 20px;
  color: #fff;
  background: #63BFAA;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }

  .sect2 .ctx {
    padding: 10px 40px;
  }

  .sect3 .ctx {
    padding: 10px 40px 100px;
  }

  .sect4 .sectTit {
    margin: -80px 0 -50px 0;
  }

  .sect4 .specList .item:nth-child(1),
  .sect4 .specList .item:nth-child(2),
  .sect4 .specList .item:nth-child(3) {
    flex: 0 0 32%;
    margin: 10px 0;
  }

  .sect4 .specList .item:nth-child(4),
  .sect4 .specList .item:nth-child(5) {
    flex: 0 0 49%;
    margin: 10px 0;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect2 .ctx {
    padding: 0 20px;
  }

  .sect3 .ctx {
    padding: 10px 20px 40px;
  }

  .sect3 .tuo {
    flex-wrap: wrap;
    margin: 20px 0;
  }

  .sect3 .tuo .sign {
    flex: 0 0 100%;
  }

  .sect3 .tuo .sign img {
    width: 40%;
    margin: 0 30% 10px;
  }

  .sect3 .tuo .desp {
    flex: 0 0 100%;
    margin: 0;
  }

  .sect3 .left {
    width: 100%;
    margin: 10px 0;
  }

  .sect3 .right {
    width: 100%;
  }

  .sect4 .sectTit {
    width: 150px;
    margin: -100px 0 -50px 0;
    padding: 42px 0 0;
    font-size: 24px;
  }

  .sect4 .specList .item {
    flex: 0 0 100%;
    margin: 10px 0;
  }

  .sect5 .isoList .item {
    flex: 0 0 100%;
  }

  .sect5 .isoList .item .txt{
    width: 100%;
    margin: 0;
    font-size: 16px;
  }

  .sect5 .isoList .item .txt .tit {
    margin: 5px 0;
  }
}
</style>
